import { combineReducers } from "redux";

//IMPORT REDUCER!
import ReducerTypeOne from "./ReducerTypeOne";

//Combine all reducers
export default combineReducers({
  typeOne: ReducerTypeOne,
});
